import { Card } from '@wartek-id/card'

import StateLoading from 'app/KinerjaKSPage/components/StateLoading'

import type { FC } from 'react'

interface CardStateLoadingProps {
  onClick?: () => void
}

const CardStateLoading: FC<CardStateLoadingProps> = () => {
  return (
    <Card className="p-9">
      <StateLoading />
    </Card>
  )
}
export default CardStateLoading
